const gridCountriesInit = (block) => {
    const blocks = block
        ? block[0].querySelectorAll('.bn-grid-countries')
        : document.querySelectorAll('.bn-grid-countries');

    if (!blocks || !blocks.length) return;

    blocks.forEach((el) => {
        const navBtns = el.querySelectorAll('.bn-grid-countries__nav-btn');
        const cards   = el.querySelectorAll('.bn-grid-countries__card');
        const empty   = el.querySelector('.bn-grid-countries__empty');

        navBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                const filter = btn.getAttribute('data-filter');

                // Aktywny przycisk
                el.querySelectorAll('.bn-grid-countries__nav-item').forEach((item) => {
                    item.classList.remove('is-active');
                });
                btn.closest('.bn-grid-countries__nav-item').classList.add('is-active');

                // Filtrowanie kart
                let visible = 0;
                cards.forEach((card) => {
                    const cats = card.getAttribute('data-categories') || '';
                    const show = filter === 'all' || cats.split(' ').includes(filter);
                    card.style.display = show ? '' : 'none';
                    if (show) visible++;
                });

                // Komunikat o braku wyników
                if (empty) {
                    empty.style.display = visible === 0 ? '' : 'none';
                }
            });
        });
    });
};

document.addEventListener('DOMContentLoaded', () => {
    if (
        document.body &&
        !document.body.classList.contains('block-editor-page') &&
        !document.body.classList.contains('block-editor-iframe__body')
    ) {
        gridCountriesInit();
    } else if (window.acf) {
        window.acf.addAction('render_block_preview/type=bn/grid-countries', gridCountriesInit);
    }
});
